import React from 'react';
import { Loader } from '@nile/components';
import styled from 'styled-components';

function ContentLoading(props) {
  return (
    <Wrapper className="loader-wrap">
      <Loader />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export default ContentLoading;
